var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('../templates/window.ejs');

module.exports = Backbone.View.extend({
    className: 'window',
    events: {
        'click .facebook': 'routeFacebook',
        'click .twitter': 'routeTwitter',
        'click .google': 'routeGoogle'
    },

    initialize: function(options) {
        _.bindAll(this, 'render');

        try {
            if (_.isUndefined(options.controller)) {
                throw Error(
                    'The controller is a dependency. Please inject the controller into the view.'
                );
            }
        } catch (e) {
            console.log(e);
        }

        this.controller = options.controller;
        this.share = options.share;

        console.log('Window view initialized', this.controller, this.model);
    },
    /**
     *
     */
    render: function() {
        var scope = {};
        var model = this.model;
        var cms = this.controller.Models.Cms.get('social');
        var twShare = this.share.tweet_copy;
        var googlePlus = cms.fb.share.link;

        console.log(twShare);
        //Build Twitter share link and info
        var twShareUrl = 'https://twitter.com/intent/tweet';
        twShareUrl +=
            '?text=' +
            encodeURIComponent(twShare) +
            ' ' +
            encodeURIComponent(location);

        scope.twShareUrl = twShareUrl;
        scope.google = googlePlus;
        scope.share = this.share;

        _.extend(scope, model);

        console.log('extended scope: ', scope);
        console.log('model: ', model);

        this.$el.html(template(scope));
        $('footer').addClass('posfix');
        $('.container-fluid').addClass('closed');

        return this;
    },
    /**
     *
     */
    routeFacebook: function(e) {
        e.preventDefault();
        var shareParams = this.buildFacebookShareURL();
        // console.log("Share", shareParams);

        this.controller.Models.Facebook.share(shareParams);
        this.controller.trackEvent(e, 'eventShareFacebook');
    },
    /**
     *
     */
    routeGoogle: function(e) {
        //e.preventDefault();
        this.controller.trackEvent(e, 'eventShareGooglePlus');
        console.log('route to google');
    },
    /**
     *
     */
    routeTwitter: function(e) {
        //e.preventDefault();
        this.controller.trackEvent(e, 'eventShareTwitter');
        console.log('route to twitter');
    },
    /**
     *
     */
    buildFacebookShareURL: function() {
        var data = this.controller.Models.Cms.get('social').fb.share;

        var params = {
            name: data.name,
            description: data.description,
            image: data.picture,
            caption: data.caption,
            link: data.link,
            href: data.link,
            appId: this.controller.Models.Facebook.get('appId'),
            display: data.display,
            redirect_uri: data.redirect_uri
        };

        var url = window.location.href.split('?')[0];
        url = url + 'share/?' + $.param(params);

        return url;
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/window.js
// module id = 239
// module chunks = 0